import { createI18n } from 'vue-i18n'

// All locale JSON files are loaded eagerly so translations are globally
// available before any component mounts. The JSON files stay organised
// per-component in their locales/ folders — the glob pattern here is the
// only place that picks them up. <i18n> SFC blocks are not used because
// in Composition API mode they require useI18n() to be called in every
// component setup; the glob approach is simpler and more reliable.
type LocaleFile = Record<string, Record<string, unknown>>

function deepMerge(
  target: Record<string, unknown>,
  source: Record<string, unknown>,
): void {
  for (const key of Object.keys(source)) {
    const srcVal = source[key]
    const tgtVal = target[key]
    if (
      srcVal !== null && typeof srcVal === 'object' && !Array.isArray(srcVal) &&
      tgtVal !== null && typeof tgtVal === 'object' && !Array.isArray(tgtVal)
    ) {
      deepMerge(tgtVal as Record<string, unknown>, srcVal as Record<string, unknown>)
    } else {
      target[key] = srcVal
    }
  }
}

const localeModules = import.meta.glob<string>(
  [
    './assets/locales/*.json',
    './components/**/locales/*.json',
    './components/**/i18n-*.json',
  ],
  { eager: true, query: '?raw', import: 'default' }
)

const messages: Record<string, Record<string, unknown>> = {}
for (const rawJson of Object.values(localeModules)) {
  const mod = JSON.parse(rawJson) as LocaleFile
  for (const [locale, keys] of Object.entries(mod)) {
    if (!messages[locale]) messages[locale] = {}
    deepMerge(messages[locale], keys)
  }
}

const datetimeFormats = {
  'en': {
    short: {
      month: 'numeric', day: 'numeric', year: 'numeric'
    },
    long: {
      month: 'numeric', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: 'numeric'
    }
  },
  'de': {
    short: {
      day: 'numeric', month: 'numeric',  year: 'numeric'
    },
    long: {
      day: 'numeric', month: 'numeric', year: 'numeric',
      hour: 'numeric', minute: 'numeric'
    }
  }
} as const

export default createI18n({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  fallbackWarn: false,
  datetimeFormats,
  messages: messages as any,
})

